import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'coupon_detail',
      component: resolve => require(["@/pages/coupon_detail"], resolve),                      
    },
		
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js